import { IProjectEntityCounts } from "models/projectEntityCounts.models";
import { QueryAPIKey } from "utils/constants/api.constants";
import queries from "../../queries";

export const projectCountsQueryConfig = {
  projectCounts: {
    query: queries.project.projectCounts,
    queryKey: [QueryAPIKey.GetProjectCounts],
    errorMessageKey: "getProjectCountsFailure",
    queryOptions: {
      select: (data: {
        projectCounts: IProjectEntityCounts;
      }): IProjectEntityCounts => data.projectCounts,
    },
  },
};
